import CloseIcon from '@mui/icons-material/Close'
import { Box, Button, Grid, IconButton, Tooltip, Typography } from '@mui/material'
import { useContext } from 'react'
import { useNavigate } from 'react-router-dom'
import { ApplicationContext } from '../App'
import { Identity } from '../interfaces/applicationContext'
import { dismissNotification } from '../services/claimsService'

const getNotificationLabel = (notification: any, identities: Identity[]) => {
    const sender = identities.find((identity) => identity.did === notification.sender)?.displayName
    if (notification.type === '837') {
        return `${sender} granted you access to 837 with claim number ${notification.claimOrPatientNumber}`
    } else if (notification.type === '835') {
        return `${sender} granted you access to 835 EDI with patient control number ${notification.claimOrPatientNumber}`
    } else if (notification.type === 'message') {
        return `${sender} granted you access to message in claim ${notification.claimOrPatientNumber}`
    } else if (notification.type === 'error') {
        return `An error occurred while processing claim ${notification.claimOrPatientNumber}`
    }
}

export const Notifications: React.FC = () => {
    const { identities, notifications, setLastUpdate } = useContext(ApplicationContext)
    const navigate = useNavigate()

    const handleDismissNotification = (id: string) => {
        dismissNotification(id)
            .then((response) => {
                if (response.data) {
                    setLastUpdate(new Date().getTime())
                } else {
                    // TODO
                }
            })
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            .catch((err: Error) => {
                // TODO
            })
    }

    return (
        <Grid container direction="column" style={{ padding: '40px' }}>
            <Grid item>
                <Typography style={{ marginBottom: '30px' }} variant="h3">
                    Notifications
                </Typography>
            </Grid>
            <Grid item>
                {notifications.map((notification: any) => (
                    <Box
                        key={notification.id}
                        style={{
                            backgroundColor: '#F2F6F9',
                            padding: '15px',
                            borderRadius: '5px',
                            marginBottom: '20px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                        }}
                    >
                        <Typography>
                            {getNotificationLabel(notification, identities || [])}
                        </Typography>
                        <Box style={{ display: 'flex', alignItems: 'center' }}>
                            <Button
                                variant="contained"
                                disableElevation={true}
                                style={{ borderRadius: '18px', marginRight: '10px' }}
                                onClick={() =>
                                    navigate(
                                        `/claims/${notification.claimOrPatientNumber}/${
                                            notification.type === 'message' ? 'history' : 'summary'
                                        }`,
                                    )
                                }
                            >
                                View Claim
                            </Button>
                            <Tooltip title="Dismiss notification" arrow>
                                <IconButton
                                    onClick={() => handleDismissNotification(notification.id)}
                                >
                                    <CloseIcon />
                                </IconButton>
                            </Tooltip>
                        </Box>
                    </Box>
                ))}
                {notifications.length === 0 && (
                    <Typography
                        variant="h6"
                        style={{ marginTop: '200px', textAlign: 'center', color: 'grey' }}
                    >
                        There are no pending notifications
                    </Typography>
                )}
            </Grid>
        </Grid>
    )
}
